module.exports = __webpack_public_path__ + "static/media/work_personality.5bc530e4.svg";